import { StaffRoutingContext } from '@layouts/admin/staffRoutingContext';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

const Resources: React.FC = () => {
  const { routes } = useContext(StaffRoutingContext);

  const usefulRoutes = routes.filter((route) => route.inResources);

  return (
    <div className='links-blue text-xl'>
      <h1 className='font-semibold mb-4'>
        Our records reflect you have access to the following administrative resources:
      </h1>
      <ul className='list-none'>
        {usefulRoutes.map((route, index) => (
          <li key={index}>
            <Link to={route.to}>{route.text ?? 'Unknown Resource'}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Resources;
